// eslint-disable-next-line vue/prefer-import-from-vue
export { hyphenate, camelize, capitalize } from '@vue/shared'

export function measureText(text, font = '14px Microsoft YaHei') {
    const canvas = measureText.canvas || (measureText.canvas = document.createElement('canvas'))
    const context = canvas.getContext('2d')
    context.font = font
    const metrics = context.measureText(text)
    // const actual = Math.abs(metrics.actualBoundingBoxLeft) + Math.abs(metrics.actualBoundingBoxRight)
    return Math.ceil(metrics.width)
}
